import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, Fragment } from 'react';
import { addLivePersonChatScriptToDocument } from './add-live-person-chat-script-to-document';
export function LivePersonChat() {
    const [livePersonChatScriptLoaded, setLivePersonChatScriptLoaded] = useState(false);
    useEffect(() => {
        if (!livePersonChatScriptLoaded) {
            addLivePersonChatScriptToDocument();
            setLivePersonChatScriptLoaded(true);
        }
    }, [livePersonChatScriptLoaded]);
    return _jsx(Fragment, {});
}
